export const validateAmenities = (formData) => {

    const {amenities} = formData
    const errors = [];
  
    if (!amenities) {
      errors.push({
        error: "Amenities field is required",
        errorType: 'amenities'
      })
      return { errors, isValid: false };
    }
  
  
    if (amenities.length === 0) {
      errors.push({
        error: "No amenities selected. Consider adding at least one amenity",
        errorType: 'amenities'
      })
      return { errors, isValid: false };
    }
  
    return {
      errors,
      isValid: Object.keys(errors).length === 0,
    };
  };
  